import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";
import { IApplicationScreenTypeModel } from "../../models";

export class ApplicationScreenTypeService {
  get url(): string {
    return "/ApplicationsScreensTypes";
  }

  public select = (): Observable<IApplicationScreenTypeModel[]> =>
    new Observable(
      (observer: Observer<IApplicationScreenTypeModel[]>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.GET,
          url: `${this.url}/Select`,
        })
    );
}
